import React, {Dispatch, FC, MutableRefObject, SetStateAction, useEffect} from "react";
import {
  getLabelName,
  getLookUpItemValue,
  getOriginalValueInCurrency, handleSelectInputChange,
  isArabicCurrentLanguage,
  updateStateDynamically,
} from "../../../utils";
import {
  getTextBoxNumericOrDefaultValue,
  handleCalculateItemRecordValuesUpdate,
  handleChangeNewRecordItemCalculation,
  handleSearchAndFilterItems,
  transactionItemInitialValues
} from "../common/businessLogic/transactionBl";
import {ButtonBox, SelectBox, TextBox} from "../..";
import {
  ActionTypeEnum,
  ChangeItemValueTypeEnum, ItemPricingAndStockDetailResponseModel,
  ItemSearchTypeEnum,
  KeyValueStateModel,
  LookupItemModel,
  RequestActionModel,
  TransactionClientConfigurationModel,
  TransactionDetailResponseModel,
  TransactionItemResponseModel,
  UserConfigurationModel
} from "../../../models";
import {InputActionMeta} from "react-select";

export const RegisterTransactionItem: FC<{
  transactionConfiguration:TransactionClientConfigurationModel;
  data: TransactionDetailResponseModel;
  lookups: Record<string, LookupItemModel[]>;
  lookupRefs: Record<string, React.MutableRefObject<any>>;
  transactionItemObject: TransactionItemResponseModel;
  setTransactionItemObject: Dispatch<
    SetStateAction<TransactionItemResponseModel>
  >;
  userConfiguration:UserConfigurationModel,
  setItemList: Dispatch<SetStateAction<LookupItemModel[]>>;
  setItemPerCategoryList: Dispatch<SetStateAction<LookupItemModel[]>>;
  onActionEvent: (o: RequestActionModel) => void;
}> = ({
  transactionConfiguration,
  data,
  lookups,
   lookupRefs,
  transactionItemObject,
  setTransactionItemObject, userConfiguration,
  setItemList,
  setItemPerCategoryList,
  onActionEvent = () => {},
}) => {
  //#region variables
  const isArabic = isArabicCurrentLanguage();
  const discountPercentageMaxValue: number = 50;
  const {
    itemList = [],
    itemsPerCategoryList = [],
    categoryList = [],
    calcTypeList = [],
    storeList=[]
  } = lookups;
  const{itemCategorySelectBoxMultiselectRef,itemSelectBoxMultiselectRef,StoreSelectBoxMultiselectRef}=lookupRefs;
  //#endregion
  //#region functions
  const updateTransactionItemObjectState = async (
    key?: string | null,
    value?: any | null,
    keyValues?: KeyValueStateModel[] | null
  ) => {
    await updateStateDynamically(
      setTransactionItemObject,
      transactionItemObject,
      key,
      value,
      keyValues
    );
  };
  //#endregion
  //#region useEffect
  useEffect(() => {
    const fill = async () => {
      if (transactionItemObject.storeId == null  && transactionConfiguration.hasSingleStore && storeList?.length > 0) {
        setTransactionItemObject({
          ...transactionItemInitialValues,
          storeId: Number(storeList[0].value),
        });
      }
      if (transactionConfiguration.hasSingleStore && (itemsPerCategoryList == null || itemsPerCategoryList.length == 0)) {
        setItemPerCategoryList(itemList);
      }
    };
    fill().then(() => {
    });
  },[ data.defaultStoreId,transactionItemObject.storeId,transactionItemObject,storeList]);
  // useEffect(() => {
  //   const fill = async () => {
  //     if (transactionConfiguration.hasSingleStore && ( itemsPerCategoryList==null || itemList.length == 0)) {
  //      setItemPerCategoryList(itemList);
  //   }};
  //     fill().then(() => {
  //   });
  // },[ data.defaultStoreId,transactionItemObject.storeId]);
  //#endregion
  // console.log('res_x_1_itemsPerCategoryList',itemsPerCategoryList.length)
  // console.log('res_x_1_transactionConfiguration',transactionConfiguration);
  // console.log('res_x_1_transactionItemObject.storeId',transactionItemObject.storeId)
  // console.log('res_x_1_data.defaultStoreId',data.defaultStoreId)
  //#region html
  return (
    <>
      <div
          // className="row row-cols-1 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 g-md-4 g-sm-4"
          className="row g-3"
        >
          {!transactionConfiguration.hasSingleStore &&
              <div className="col-12 col-md-4">
              <SelectBox
                id="StoreSelectBox"
                labelName={getLabelName("Store")}
                isSingleSelect={true}
                selectedValues={
                  transactionItemObject.storeId != null
                    ? [transactionItemObject.storeId.toString()]
                    : []
                }
                source={storeList}
                //@ts-ignore
                multiselectRef={(node: MutableRefObject<any>) =>
                  node ? (StoreSelectBoxMultiselectRef.current = node) : null
                }
                onStatusChange={async (e: LookupItemModel) => {
                  const value = getLookUpItemValue(e);
                  if (value !== null && value !== undefined) {
                    itemSelectBoxMultiselectRef.current && itemSelectBoxMultiselectRef.current.clearValue();
                    itemCategorySelectBoxMultiselectRef.current && itemCategorySelectBoxMultiselectRef.current.clearValue();
                    setTransactionItemObject({
                      ...transactionItemInitialValues,
                      storeId: Number(value),
                      Categ_ID: null,
                    });
                  } else {
                    setTransactionItemObject({
                      ...transactionItemInitialValues,
                      storeId: null,
                      Categ_ID: null,
                    });
                  }
                  await handleSearchAndFilterItems({
                    setItemsState: setItemList,
                    setItemsPerCategoryState: setItemPerCategoryList,
                    setTransactionItemObjectState: setTransactionItemObject,
                    itemList: itemList,
                    itemPerCategoryList: itemsPerCategoryList,
                    calcTypeList: calcTypeList,
                    isArabic: isArabic,
                    transactionDetailObject: data,
                    transactionItemObject: { ...transactionItemObject, storeId: value != null ? Number(value) : null },
                    userSetting: userConfiguration,
                    transactionConfiguration: transactionConfiguration,
                    searchType: ItemSearchTypeEnum.none,
                    searchValue: null,
                  });
                }}
              />
            </div>
          }
        <div className="col-12 col-md-4">
            <SelectBox
              id="categorySelectBox"
              labelName={getLabelName("Category")}
              isSingleSelect={true}
              selectedValues={
                transactionItemObject.Categ_ID !== null &&
                  transactionItemObject.Categ_ID !== undefined
                  ? [transactionItemObject.Categ_ID.toString()]
                  : []
              }
              source={categoryList}
              //multiselectRef={itemCategorySelectBoxMultiselectRef}
              //@ts-ignore
              multiselectRef={(node: MutableRefObject<any>) =>
                node ? (itemCategorySelectBoxMultiselectRef.current = node) : null
              }
              onStatusChange={async (e: LookupItemModel) => {
                const value = getLookUpItemValue(e);
                if (value != null) {
                  itemSelectBoxMultiselectRef.current && itemSelectBoxMultiselectRef.current.clearValue();
                  setTransactionItemObject({
                    ...transactionItemObject,
                    Categ_ID: Number(value),
                  });
                  //await updateTransactionItemObjectState("Categ_ID", value);
                } else {
                  setTransactionItemObject({
                    ...transactionItemObject,
                    Categ_ID: null,
                  });
                }
                await handleSearchAndFilterItems({
                  setItemsState: setItemList,
                  setItemsPerCategoryState: setItemPerCategoryList,
                  setTransactionItemObjectState: setTransactionItemObject,
                  itemList: itemList,
                  itemPerCategoryList: itemsPerCategoryList,
                  calcTypeList: calcTypeList,
                  searchType: ItemSearchTypeEnum.none,
                  isArabic: isArabic,
                  transactionDetailObject: data,
                  transactionItemObject: { ...transactionItemObject, Categ_ID: value != null ? Number(value) : null },
                  userSetting: userConfiguration,
                  transactionConfiguration: transactionConfiguration,
                  searchValue: null,
                });
              }}
            />
          </div>
        <div className="col-12 col-md-8">
            <SelectBox
              id="itemsSelectBox"
              labelName={getLabelName("Item")}
              isSingleSelect={true}
              isDisabled={(itemsPerCategoryList.length == 0)}
              selectedValues={
                transactionItemObject.ItemUnit_ID !== null &&
                  transactionItemObject.ItemUnit_ID !== undefined
                  ? [transactionItemObject.ItemUnit_ID.toString()]
                  : []
              }
              source={itemsPerCategoryList ?? []}
              //multiselectRef={itemSelectBoxMultiselectRef}
              //@ts-ignore
              multiselectRef={(node: MutableRefObject<any>) =>
                node ? (itemSelectBoxMultiselectRef.current = node) : null
              }
              onInputChange={(inputValue: string, actionMeta: InputActionMeta) => {
                return handleSelectInputChange(inputValue, actionMeta, {
                  localList: itemsPerCategoryList || [],
                  apiSearchFn: async (searchValue) => {
                    await handleSearchAndFilterItems({
                      setItemsState: setItemList,
                      setItemsPerCategoryState: setItemPerCategoryList,
                      setTransactionItemObjectState: setTransactionItemObject,
                      itemList: itemList,
                      itemPerCategoryList: itemsPerCategoryList,
                      calcTypeList: calcTypeList,
                      isArabic: isArabic,
                      transactionDetailObject: data,
                      transactionItemObject: transactionItemObject,
                      userSetting: userConfiguration,
                      transactionConfiguration: transactionConfiguration,
                      searchType: ItemSearchTypeEnum.name,
                      searchValue: searchValue,
                    });
                  },
                });
              }}
              onStatusChange={async (e: LookupItemModel) => {
                const value = getLookUpItemValue(e);
                const _item = itemsPerCategoryList.find(p => p.value == value);
                if (value != null) {
                  const itemOtherValue = _item?.otherValue as ItemPricingAndStockDetailResponseModel
                  const transactionItemObj = await handleChangeNewRecordItemCalculation(
                    {
                      ...transactionItemObject,
                      ItemUnit_ID: Number(value),
                      PriceCost: itemOtherValue.costPrice,
                      IsGatherItem: itemOtherValue.hasGatherItem,
                      TaxCalculatedValueOfGatherItem: itemOtherValue.taxCalculatedValueOfGatherItem,
                      barCode: _item?.otherValue?.barCode ?? null,
                    },
                    data,
                    userConfiguration.userTransactionSetting,
                    transactionConfiguration.transactionType,
                    itemList,
                    calcTypeList
                  );
                  transactionItemObj.ItemInstore_ID = _item?.otherValue?.itemInStoreId ?? null;
                  transactionItemObj.PriceCost = _item?.otherValue?.costPrice ?? 0;
                  setTransactionItemObject(transactionItemObj);
                } else {
                  setTransactionItemObject({
                    ...transactionItemInitialValues,
                    ItemUnit_ID: null,
                    ItemInstore_ID: null,
                    barCode: null
                  });
                }
              }}
            />
          </div>
        <div className="col-12 col-md-4">
            <TextBox
              labelName={getLabelName("Price")}
              isReadOnly={!userConfiguration.userTransactionSetting.EnableShangPrice}
              inputName={"Unit_PriceInCurrencyCalculated"}
              type="price"
              inputValue={transactionItemObject.Unit_PriceInCurrencyCalculated}
              onChange={async (e: any) => {
                const value: number = getTextBoxNumericOrDefaultValue(e);
                await updateTransactionItemObjectState(null, null, [
                  {
                    key: "Unit_PriceInCurrencyCalculated",
                    value: value,
                  },
                  {
                    key: "changeValueType",
                    value: ChangeItemValueTypeEnum.ChangePriceInCurrency,
                  },
                ]);
              }}
              onBlur={async () => {
                const obj = handleCalculateItemRecordValuesUpdate(
                  transactionItemObject
                );
                setTransactionItemObject(obj);
              }}
            />
          </div>
          {userConfiguration.companySetting.ApplyTax && (
            <div className="col-12 col-md-4">
          <TextBox
            labelName={getLabelName("PriceSaleWithTax")}
            isReadOnly={!userConfiguration.userTransactionSetting.EnableShangPrice}
            inputName={"UnitPriceWithTaxInCurrency"}
            type="price"
            inputValue={transactionItemObject.UnitPriceWithTaxInCurrency}
            onChange={async (e: any) => {
              const value: number = getTextBoxNumericOrDefaultValue(e);
              await updateTransactionItemObjectState(null, null, [
                {
                  key: "UnitPriceWithTaxInCurrency",
                  value: value,
                },
                {
                  key: "changeValueType",
                  value: ChangeItemValueTypeEnum.ChangePriceWithTaxInCurrency,
                },
              ]);
            }}
            onBlur={async () => {
              const obj = handleCalculateItemRecordValuesUpdate(
                transactionItemObject
              );
              setTransactionItemObject(obj);
            }}
          />
            </div>
        )}
        <div className="col-12 col-md-4">
        <TextBox
          labelName={getLabelName("Quantity")}
          inputName={"Quantity"}
          type="quantity"
          inputValue={transactionItemObject.Quantity}
          onChange={async (e: any) => {
            const value: number = getTextBoxNumericOrDefaultValue(e);
            await updateTransactionItemObjectState("Quantity", value);
          }}
        />
        </div>
        {userConfiguration.userTransactionSetting.EnableDiscount &&
            <div className="col-12 col-md-2">
            <TextBox
          labelName={getLabelName("Discount")}
          isReadOnly={!userConfiguration.userTransactionSetting.EnableDiscount}
          inputName={"ItemDiscountInCurrency"}
          type="price"
          inputValue={transactionItemObject.ItemDiscountInCurrency}
          onChange={async (e: any) => {
            const value: number = getTextBoxNumericOrDefaultValue(e);
            await updateTransactionItemObjectState(null, null, [
              {
                key: "ItemDiscount",
                value: getOriginalValueInCurrency(
                  value,
                  data.ValueCurrency || 0
                ),
              },
              { key: "ItemDiscountInCurrency", value: value },
              { key: "changeValueType", value: ChangeItemValueTypeEnum.None },
            ]);
          }}
        />
       </div>
        }
        {userConfiguration.userTransactionSetting.EnableDiscount &&
            <div className="col-12 col-md-2">
            <TextBox
          labelName={getLabelName("Discount %")}
          isReadOnly={!userConfiguration.userTransactionSetting.EnableDiscount}
          inputName={"ItemDiscountRatio"}
          type="price"
          inputValue={transactionItemObject.ItemDiscountRatio}
          onChange={async (e: any) => {
            const value: number = getTextBoxNumericOrDefaultValue(e);
            if (value <= discountPercentageMaxValue) {
              await updateTransactionItemObjectState(
                "ItemDiscountRatio",
                value
              );
            }
          }}
        />
        </div>
        }
        {userConfiguration.userTransactionSetting.EnableButonAdd &&
            // <div className="row mt-3">
          <div className="col-12 d-flex justify-content-end">
          <ButtonBox
            iconType="plus"
            id="addItemBtn"
            variant=""
            className="btn-gradient-info me-2"
            size="sm"
            onClick={async () => {
              onActionEvent({
                request: transactionItemObject,
                otherValue:itemsPerCategoryList,
                action: ActionTypeEnum.AddItem,
              });
              //await handleAddItem(transactionItemObject, transactionType);
            }}
          >
            {getLabelName("Add")}
          </ButtonBox>
        </div>
      // </div>
        }
      </div>
    </>
  );
  //#endregion
};

// // Component 1: Searching for items
// <SelectBox
//     onInputChange={(inputValue, actionMeta) => {
//       return handleSelectInputChange(inputValue, actionMeta, {
//         localList: itemsPerCategoryList || [],
//         apiSearchFn: async (searchValue) => {
//           // This component uses handleSearchAndFilterItems
//           await handleSearchAndFilterItems({
//             setItemsState: setItemList,
//             setItemsPerCategoryState: setItemPerCategoryList,
//             // ...other parameters
//             searchType: ItemSearchTypeEnum.name,
//             searchValue: searchValue,
//           });
//         }
//       });
//     }}
// />
//
// // Component 2: Searching for customers
// <SelectBox
//     onInputChange={(inputValue, actionMeta) => {
//       return handleSelectInputChange(inputValue, actionMeta, {
//         localList: customerList || [],
//         // Custom filter function specific to customers
//         localFilterFn: (customer, search, isArabic) => {
//           return customer.fullName.toLowerCase().includes(search.toLowerCase()) ||
//               customer.phoneNumber.includes(search);
//         },
//         apiSearchFn: async (searchValue) => {
//           // This component uses a different search function
//           const results = await searchCustomersByNameOrPhone(searchValue);
//           setCustomerList(results);
//         }
//       });
//     }}
// />
//
// // Component 3: Searching for products with image preview
// <SelectBox
//     onInputChange={(inputValue, actionMeta) => {
//       return handleSelectInputChange(inputValue, actionMeta, {
//         localList: productList || [],
//         minChars: 2, // Different minimum character threshold
//         debounceTime: 500, // Different debounce time
//         apiSearchFn: async (searchValue) => {
//           // This component uses yet another search function
//           setIsLoading(true);
//           try {
//             const response = await fetchProductsWithImages(searchValue, categoryId);
//             setProductList(response.data);
//             setTotalResults(response.totalCount);
//           } finally {
//             setIsLoading(false);
//           }
//         }
//       });
//     }}
// />